import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const RangeHandle = styled.button`
  position: absolute;
  top: -12px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border: none;
  padding: 0;
  border-radius: 16px;
  background-color: #fff;
  background-size: 22px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: grab;
  outline: none;
  box-shadow: 0 4px 2px 0 rgba(0, 0, 0, 0.32);
  transition: transform 0.15s ease-out;

  &:active {
    cursor: grabbing;
  }

  &:focus {
    box-shadow: 0 0 2px 3px ${COLORS.primary};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export default RangeHandle;
